
export function sirenSiretSearchFormater(query: string) {

  if (/^[0-9 \t]*$/.test(query)) {
    return query.replace(/ |\t/g, '')
  }
  return query
}
